module.exports = __webpack_public_path__ + "static/media/ic_联系我们_pr.71938a01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_联系我们_pr.svg
// module id = 187
// module chunks = 0